<template>
    <div class="row mt-5">
        <div class="col-12">
            <table :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="table">
                <thead>
                    <tr class="text-light text-center" style="background-color: #2a3042 !important">
                        <th scope="col">{{ $t('hr_employees.penalty_id') }}</th>
                        <th scope="col">{{ $t('hr_employees.type') }}</th>
                        <th scope="col">{{ $t('hr_employees.total_amount') }}</th>
                        <th scope="col">{{ $t('hr_employees.paid_amount') }}</th>
                        <th scope="col">{{ $t('hr_employees.month') }}</th>
                        <th scope="col">{{ $t('hr_employees.year') }}</th>
                        <th scope="col">{{ $t('hr_employees.description') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="text-center" v-for="(item, index) in penalty" :key="index">
                        <td>{{ item.hr_employee_id }}</td>
                        <td>{{ item.hr_award_type.name }}</td>
                        <td>{{ Number(item.total_amount).toLocaleString() }}</td>
                        <td>{{ Number(item.paid_amount).toLocaleString() }}</td>
                        <td>{{ item.month }}</td>
                        <td>{{ item.year }}</td>
                        <td>{{ item.descr }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="d-flex justify-content-center mt-4">
            <BPagination v-model="currentPage" :total-rows="rows" :per-page="perPage" />
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            penalty: {},
            rows: 0,
            perPage: 10,
            currentPage: 1
        };
    },
    methods:{
        GetPenalty() {
            this.http.post('hr-awards/awards', {emp_id: this.$route.params.id, limit: this.perPage, page: this.currentPage}).then((res) => {
                this.penalty = res.data;
                this.rows = res.total;
                console.log('ahhhh', typeof this.penalty)
            })
        }
    },
    mounted() {
        this.GetPenalty();
    }
}
</script>
<style lang="">
    
</style>